
      import NavButton from './utils/NavButton.js';
      
      // Injecter la navigation pour la page d'accueil (icônes seules)
      document.addEventListener('DOMContentLoaded', () => {
        const nav = document.getElementById('nav-container');
        if (nav) {
          nav.innerHTML = NavButton.createHomeNavigation();
        }
      });
    